import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
import { kpiDataDownload } from '@/store/function/common/kpiDataDownload';
import { getKpiApi } from '@/api';
import { isDateAfterToday } from '@/utils/datetime';

import { DateTime } from 'luxon';
export default {
  name: 'KpiReport',
  data: function data() {
    return {
      selectedYearMonth: DateTime.local().setZone('Asia/Taipei').toFormat('yyyy-MM'),
      searchedYearMonth: '',
      isLoadingData: false,
      isDownloadingData: false,
      tableFields: [{
        key: 'factoryName',
        label: '案場名稱',
        stickyColumn: true
      }, {
        key: 'capacity',
        label: '案場容量',
        sortable: true
      }, {
        key: 'prAll',
        label: '實際 PR 值 (%)',
        sortable: true
      }, {
        key: 'PRGoalContract',
        label: '目標 PR 值 (%)',
        sortable: true
      }, {
        key: 'guaranteePR',
        label: '保證 PR 值 (%)',
        sortable: true
      }, {
        key: 'acpAll',
        label: '實際發電量 (kWh)',
        sortable: true
      }, {
        key: 'acpGoalContract',
        label: '目標發電量 (kWh)',
        sortable: true
      }, {
        key: 'guaranteePower',
        label: '保證發電量 (kWh)',
        sortable: true
      }, {
        key: 'prAchieveGoal',
        label: '實際值 / 目標值',
        sortable: true
      },
      // t1
      {
        key: 'prAchieveGuarantee',
        label: '實際值 / 保證值',
        sortable: true
      },
      // t2
      {
        key: 'powerAchieveGoal',
        label: '實際值 / 目標值',
        sortable: true
      },
      // t3
      {
        key: 'powerAchieveGuarantee',
        label: '實際值 / 保證值',
        sortable: true
      } // t4
      ],
      tableApiData: [],
      summaryApiData: {},
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100]
    };
  },
  computed: {
    summaryData: function summaryData() {
      return {
        searchedYear: this.searchedYearMonth.split('-')[0] || '--',
        searchedMonth: this.searchedYearMonth.split('-')[1] || '--',
        // PR
        PRAchievedCount: this.getNumberOrDash(this.summaryApiData.PRAchievedCount),
        // c4
        PRAchievedQualifiedCount: this.getNumberOrDash(this.summaryApiData.PRAchievedQualifiedCount),
        // d4
        PRAchievementCountRatio: this.getNumberOrDash(this.summaryApiData.PRAchievementCountRatio),
        // e4
        PRGuaranteeCount: this.getNumberOrDash(this.summaryApiData.PRGuaranteeCount),
        // f4
        PRGuaranteeQualifiedCount: this.getNumberOrDash(this.summaryApiData.PRGuaranteeQualifiedCount),
        // g4
        PRGuaranteeCountRatio: this.getNumberOrDash(this.summaryApiData.PRGuaranteeCountRatio),
        // h4
        // 發電量
        powerAchievedCount: this.getNumberOrDash(this.summaryApiData.powerAchievedCount),
        // c5
        powerAchievedQualifiedCount: this.getNumberOrDash(this.summaryApiData.powerAchievedQualifiedCount),
        // d5
        powerAchievementCountRatio: this.getNumberOrDash(this.summaryApiData.powerAchievementCountRatio),
        // e5
        powerGuaranteeCount: this.getNumberOrDash(this.summaryApiData.powerGuaranteeCount),
        // f5
        powerGuaranteeQualifiedCount: this.getNumberOrDash(this.summaryApiData.powerGuaranteeQualifiedCount),
        // g5
        powerGuaranteeCountRatio: this.getNumberOrDash(this.summaryApiData.powerGuaranteeCountRatio) // h5
      };
    },
    sortedTableData: function sortedTableData() {
      // t2 null, t2 number, t4 null, t4 number ...
      var data = this.tableApiData.slice().sort(function (a, b) {
        // t2 排序
        if (a.prAchieveGuarantee !== b.prAchieveGuarantee) {
          // 将 null 值排在前面
          if (a.prAchieveGuarantee === null) return -1;
          if (b.prAchieveGuarantee === null) return 1;

          // 其他情况按照数值大小进行排序
          return a.prAchieveGuarantee - b.prAchieveGuarantee;
        } else if (a.powerAchieveGuarantee !== b.powerAchieveGuarantee) {
          // 如果 t2 相等，t4 排序
          if (a.powerAchieveGuarantee === null) return -1;
          if (b.powerAchieveGuarantee === null) return 1;
          return a.powerAchieveGuarantee - b.powerAchieveGuarantee;
        } else if (a.prAchieveGoal !== b.prAchieveGoal) {
          // 如果 t2 和 t4 都相等，t1 排序
          if (a.prAchieveGoal === null) return -1;
          if (b.prAchieveGoal === null) return 1;
          return a.prAchieveGoal - b.prAchieveGoal;
        } else {
          // 如果 t2、t4 和 t1 都相等，t3 排序
          if (a.powerAchieveGoal === null) return -1;
          if (b.powerAchieveGoal === null) return 1;
          return a.powerAchieveGoal - b.powerAchieveGoal;
        }
      });
      return data;
    },
    tableDataNum: function tableDataNum() {
      return this.tableApiData.length;
    }
  },
  methods: {
    isDateAfterToday: isDateAfterToday,
    isNumber: function isNumber(value) {
      return typeof value === 'number' && !isNaN(value);
    },
    getNumberOrDash: function getNumberOrDash(num) {
      if (!this.isNumber(num)) return '--';
      return Math.round(num * 100) / 100;
    },
    handleSearchKpi: function handleSearchKpi() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _res$data, _res$data$data, _res$data2, _res$data2$data, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.selectedYearMonth) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", _this.$swal('請輸入查詢日期'));
              case 2:
                _this.isLoadingData = true;
                _context.prev = 3;
                _context.next = 6;
                return getKpiApi(_this.selectedYearMonth);
              case 6:
                res = _context.sent;
                if (res.data) {
                  _context.next = 9;
                  break;
                }
                return _context.abrupt("return", _this.$swal('無資料，請重新查詢'));
              case 9:
                if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && (_res$data$data = _res$data.data) !== null && _res$data$data !== void 0 && _res$data$data.dataByFactory) {
                  _this.tableApiData = res.data.data.dataByFactory;
                }
                if (res !== null && res !== void 0 && (_res$data2 = res.data) !== null && _res$data2 !== void 0 && (_res$data2$data = _res$data2.data) !== null && _res$data2$data !== void 0 && _res$data2$data.dataSummary) {
                  _this.summaryApiData = res.data.data.dataSummary;
                }
                _context.next = 16;
                break;
              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](3);
                console.log('getKpiApi error', _context.t0);
              case 16:
                _context.prev = 16;
                _this.searchedYearMonth = _this.selectedYearMonth;
                _this.isLoadingData = false;
                return _context.finish(16);
              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 13, 16, 20]]);
      }))();
    },
    downloadExcel: function downloadExcel() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.tableDataNum) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return", _this2.$swal('無下載資料，請先查詢資料'));
              case 2:
                _this2.isDownloadingData = true;
                _context2.prev = 3;
                _context2.next = 6;
                return kpiDataDownload(_this2.searchedYearMonth, _this2.tableFields, _this2.sortedTableData, _this2.summaryApiData);
              case 6:
                _context2.next = 11;
                break;
              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](3);
                console.log('kpiDataDownload error', _context2.t0);
              case 11:
                _context2.prev = 11;
                _this2.isDownloadingData = false;
                return _context2.finish(11);
              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[3, 8, 11, 14]]);
      }))();
    }
  }
};